<template>
<modal
  name="maintenanceModal"
  :adaptive="true"
  :scrollable="true"
  height="auto"
  width="90%"
  :maxWidth="450"
  class="maintenance-modal"
>
    <div class="maintenance-container">

      <div class="maintenance-icon">
        <i class="fas fa-tools"></i>
      </div>

      <h3 class="maintenance-title">
        {{ title }}
      </h3>

      <p class="maintenance-text">
        {{ message }}
      </p>

      <button class="maintenance-btn" @click="$modal.hide('maintenanceModal')">
        {{ buttonText }}
      </button>

    </div>
  </modal>
</template>

<script>
export default {
  name: "MaintenanceModal",
  props: {
    title: String,
    message: String,
    buttonText: String,
  }
}
</script>

<style scoped>

.maintenance-container {
  padding: 32px 28px;
  text-align: center;
  max-width: 380px;
  margin: auto;
}

.maintenance-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: rgba(30,34,170,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.maintenance-icon i {
  font-size: 24px;
  color: #1E22AA;
  animation: wrench-wiggle 1.6s ease-in-out infinite;
}

@keyframes wrench-wiggle {
  0%, 85%, 100% { transform: rotate(0deg); }
  88% { transform: rotate(-18deg); }
  92% { transform: rotate(14deg); }
  96% { transform: rotate(-8deg); }
}

.maintenance-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.maintenance-text {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 22px;
  line-height: 1.6;
}

.maintenance-btn {
  background: #1E22AA;
  border: none;
  color: white;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.18s ease;
}

.maintenance-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(30,34,170,0.25);
}

</style>


// WEBPACK FOOTER //
// src/components/Modal/MaintenanceModal.vue